__turbopack_context__.v({
  "image": "learn-content-carousel-card-image-module-scss-module__3A_4rq__image",
  "image--is-locked": "learn-content-carousel-card-image-module-scss-module__3A_4rq__image--is-locked",
  "image-container": "learn-content-carousel-card-image-module-scss-module__3A_4rq__image-container",
  "image-container--is-locked": "learn-content-carousel-card-image-module-scss-module__3A_4rq__image-container--is-locked",
  "image-container--is-user-authenticated": "learn-content-carousel-card-image-module-scss-module__3A_4rq__image-container--is-user-authenticated",
  "image-container__call-to-action": "learn-content-carousel-card-image-module-scss-module__3A_4rq__image-container__call-to-action",
  "image-container__icon": "learn-content-carousel-card-image-module-scss-module__3A_4rq__image-container__icon",
  "number": "learn-content-carousel-card-image-module-scss-module__3A_4rq__number",
});
